import appApiUrl from './apiUrl'

export const removePlacements = (placements, action) => {
  const userId = JSON.parse(localStorage?.redux_localstorage_simple)?.session
    ?.userId
  const token = JSON.parse(localStorage?.redux_localstorage_simple)?.session
    ?.token

  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  myHeaders.append('Authorization', `Bearer ${token}`)
  const placementNames = Object.keys(placements)
    .filter(key => placements?.[key]?.file)
    .map((key, index) => placements?.[key]?.file?.fileName)

  const stringPlacementsNames =
    placementNames.reduce((a, b, index) => {
      if (placementNames[index + 1]) return a + `"asset${index + 1}": "${b}", `
      return a + `"asset${index + 1}": "${b}", "userId": ${userId}`
    }, '{') + `, "action": "${action ? action : 'unknown'}"}`

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: stringPlacementsNames,
    redirect: 'follow'
  }

  if (placementNames?.length) {
    fetch(`${appApiUrl}campaigns/removeAssets.php`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result.message)
      })
      .catch(error => console.log('error', error))
  }
}
function getFileType(fileName) {
  const fileType = fileName.split('.')[fileName.split('.')?.length - 1]
  return fileType
}
export const removeThumbnails = (placements, action) => {
  const userId = JSON.parse(localStorage?.redux_localstorage_simple)?.session
    ?.userId
  const token = JSON.parse(localStorage?.redux_localstorage_simple)?.session
    ?.token
  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  myHeaders.append('Authorization', `Bearer ${token}`)
  const placementNames = Object.keys(placements)
    .filter(key => {
      return (
        placements?.[key]?.file &&
        getFileType(placements?.[key]?.file?.preview) !==
          getFileType(placements?.[key]?.file?.link)
      )
    })
    .map((key, index) => {
      const preview = placements?.[key]?.file?.preview
      const fileName = preview.split('/')[preview.split('/')?.length - 1]
      return fileName
    })
  const stringPlacementsNames =
    placementNames.reduce((a, b, index) => {
      if (placementNames[index + 1]) return a + `"asset${index + 1}": "${b}", `
      return a + `"asset${index + 1}": "${b}", "userId": ${userId}`
    }, '{') + `, "action": "${action ? action : 'unknown'}"}`

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: stringPlacementsNames,
    redirect: 'follow'
  }

  if (placementNames?.length) {
    fetch(`${appApiUrl}campaigns/removeAssets.php`, requestOptions)
      .then(response => response.json())
      .then(result => console.log(result.message))
      .catch(error => console.log('error', error))
  }
}
